import { render, staticRenderFns } from "./header_footer.vue?vue&type=template&id=6b2a2142&scoped=true"
import script from "./header_footer.vue?vue&type=script&lang=js"
export * from "./header_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2a2142",
  null
  
)

export default component.exports